import enumeration from "./enumeration";

const BanType = {
  LOST_TAG: "LOST_TAG",
  DEFECTIVE_TAG: "DEFECTIVE_TAG",
  OTHERS: "OTHERS",
};

export default enumeration(BanType);
